import { useMemo } from 'react';
import { WarehouseType } from '@elementary/common-ui/types';
import useCachedEnvironments from '@elementary/common-ui/hooks/useCachedEnvironments';
import useSelectedEnv from '@elementary/common-ui/hooks/useSelectedEnv';

const useSelectedWarehouseType = (): WarehouseType | undefined => {
  const selectedEnvId = useSelectedEnv();
  const { data: environments } = useCachedEnvironments();

  return useMemo(
    () =>
      environments?.find((env) => env.id === selectedEnvId)?.dwhConnection
        .warehouseType,
    [environments, selectedEnvId],
  );
};

export default useSelectedWarehouseType;
